<script setup lang="ts">
defineProps<{
  cards: Array<{
    name: string
    slug: string
    description?: string | null
    badgeLabel?: string | null
  }>
}>()

const shopPath = useShopPath()
</script>

<template>
  <div class="space-y-3">
    <NuxtLink
      v-for="card in cards"
      :key="card.slug"
      :to="shopPath(`/generator/${card.slug}`)"
      class="flex flex-col gap-4 rounded-2xl bg-gradient-to-r from-brand-700 to-brand-600 px-4 py-4 text-white shadow-sm transition hover:brightness-110 sm:flex-row sm:items-center sm:justify-between sm:px-6 sm:py-5"
    >
      <div class="flex min-w-0 items-center gap-4">
        <span class="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-white/15 ring-1 ring-white/20">
          <UIcon name="i-heroicons-calculator" class="size-7" />
        </span>
        <div class="min-w-0">
          <p class="text-lg font-bold leading-tight sm:text-xl">{{ card.name }}</p>
          <p v-if="card.description" class="mt-1 line-clamp-2 text-sm leading-5 text-white/80">
            {{ card.description }}
          </p>
        </div>
      </div>
      <div class="flex shrink-0 flex-col items-stretch gap-2 sm:items-end">
        <span class="inline-flex items-center justify-center gap-1.5 rounded-full bg-white px-5 py-2.5 text-sm font-semibold text-brand-700">
          Deschide calculator
          <UIcon name="i-heroicons-arrow-right" class="size-4" />
        </span>
        <span
          v-if="card.badgeLabel"
          class="text-center text-[11px] font-semibold tracking-wide text-white/80 uppercase sm:text-right"
        >
          {{ card.badgeLabel }}
        </span>
      </div>
    </NuxtLink>
  </div>
</template>
